import { log } from "../../shared/services/debug-logger";
import { api, apiUrl } from "../../shared/services/service";
import { AdminCronParamValues, AdminCronVariant } from "../models/admin-cron.models";
import axios from "axios";

const getRequestParams = (variant: AdminCronVariant, values: AdminCronParamValues) =>
  (variant.paramKeys ?? []).reduce<Record<string, string | boolean>>((params, key) => {
    const value = values[key];

    if (typeof value === "boolean") {
      if (value) {
        params[key] = value;
      }
      return params;
    }

    const normalized = value?.trim();
    if (normalized) {
      params[key] = normalized;
    }

    return params;
  }, {});

export const runAdminCronJob = async (variant: AdminCronVariant, values: AdminCronParamValues): Promise<unknown> => {
  log("REPO - runAdminCronJob", { variant: variant.id, method: variant.method });
  const requestParams = getRequestParams(variant, values);
  const response =
    variant.method === "POST"
      ? await api.post(`${apiUrl}/${variant.endpoint}`, requestParams)
      : await api.get(`${apiUrl}/${variant.endpoint}`, { params: requestParams });

  log("REPO - runAdminCronJob - response", { status: response.status });
  return response.data;
};

export const getAdminCronErrorMessage = (error: unknown) => {
  if (axios.isAxiosError(error)) {
    const responseData = error.response?.data as { error?: string; message?: string } | string | undefined;

    if (typeof responseData === "string") {
      return responseData;
    }

    return responseData?.error ?? responseData?.message ?? error.message;
  }

  if (error instanceof Error) {
    return error.message;
  }

  return "Cron job request failed.";
};
